module.exports = {"Mill - 20 inches x 22 inches x 40 inches":"Mill - 20 inches x 22 inches x 40 inches","lathe - 15 inches OD x 22 inches":"Lathe - 15 inches OD x 22 inches","FMS - 24 inches x 24 inches x 24 inches":"Flexible Manufacturing System (FMS) - 24 inches x 24 inches x 24 inches"}


//////////////////
// WEBPACK FOOTER
// ./src/config/machiningEnvelope.json
// module id = 5413
// module chunks = 1